const fetchSubtitles = async (url: string): Promise<string | undefined> => {

  const srtData = await fetch(url)
    .then(res => {
      if (!res.ok) {
        throw Error('Could not fetch data for resource');
      }
      return res.text();
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      // catches network errors + http not OK errors
      console.error("Unable to download file")
      return undefined
    });

  return srtData;
}

export default fetchSubtitles;